// extracted by mini-css-extract-plugin
export default {"wrap":"index_wrap_q8r3J","logo":"index_logo_VP6US"};